import React from 'react';
import { features } from '../data/products';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';

function Features() {
  const { t, language } = useLanguage();

  return (
    <section id="features" className="features">
      <div className="container">
        <h2 className="section-title">{t(translations.features.title)}</h2>
        <p className="section-subtitle">
          {language === 'it'
            ? 'Qualit\u00E0 europea, design premium, tecnologie avanzate'
            : 'Европейское качество, премиальный дизайн, передовые технологии'}
        </p>

        <div className="features-grid">
          {features[language].map((feature, index) => (
            <div key={index} className="feature-card">
              <h3 className="feature-title"><span className="feature-icon">{feature.icon}</span> {feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="features-highlight">
          <h3 className="highlight-title">{t(translations.features.highlightTitle)}</h3>
          <div className="highlight-grid">
            <div className="highlight-item">
              <span className="highlight-icon">{'\u{1F525}'}</span>
              <div>
                <h4>{t(translations.features.highlight1Title)}</h4>
                <p>{t(translations.features.highlight1Desc)}</p>
              </div>
            </div>
            <div className="highlight-item">
              <span className="highlight-icon">{'\u{1F4AA}'}</span>
              <div>
                <h4>{t(translations.features.highlight2Title)}</h4>
                <p>{t(translations.features.highlight2Desc)}</p>
              </div>
            </div>
            <div className="highlight-item">
              <span className="highlight-icon">{'\u{1F454}'}</span>
              <div>
                <h4>{t(translations.features.highlight3Title)}</h4>
                <p>{t(translations.features.highlight3Desc)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
